import { useQuery } from "@tanstack/react-query";
import { fetchCoraSettings } from "@/api/cora";
import { isCoraEnabled } from "@/config/publicEnv";
import { CORA_SETTINGS_FALLBACK } from "@/constants/cora";
import type { CoraPublicSettings } from "@/interfaces/cora";

/**
 * Cora's UI copy and opening questions from GET /api/cora/settings. Always returns usable settings:
 * the built-in fallback while the request loads, if it fails, or when Cora is switched off.
 */
export function useCoraSettings(): CoraPublicSettings {
  const { data } = useQuery({
    queryKey: ["cora", "settings"],
    queryFn: fetchCoraSettings,
    staleTime: 5 * 60 * 1000,
    enabled: isCoraEnabled(),
  });
  return data ?? CORA_SETTINGS_FALLBACK;
}
